import React from 'react';
import styles from '../../styles/search-bar.module.css';
import styles2 from '../../styles/cities/header-search-bar.module.css';
import { FaSearch, FaTimes } from 'react-icons/fa';
import { loadPlaces, openSearchPageByPlace } from '../../utils/google-maps';

class ProductSearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.title = props.title || '';
    this.subtitle = props.subtitle || '';
    this.autoCompleteInputRef = React.createRef();
    this.placesAutoCompleteRef = React.createRef();
  }

  componentDidMount() {
    loadPlaces().then(placesLibrary =>
      this.activatePlacesSearch(placesLibrary),
    );
  }
  /**
   * @function
   * @name handleInputSubmit
   * @param {event} clickevent
   */
  handleInputSubmit = event => {
    var location = this.placesAutoCompleteRef.current?.getPlace();
    openSearchPageByPlace(location);
  };

  /**
   * Activate input field and add google maps autocomplete
   * @function
   * @name activatePlacesSearch
   */
  activatePlacesSearch(placesLibrary) {
    const input = this.autoCompleteInputRef.current;
    var options = {
      componentRestrictions: {
        country: 'us',
      },
      types: ['geocode'],
      fields: ['address_components', 'geometry', 'formatted_address'],
    };
    this.placesAutoCompleteRef.current = new placesLibrary.Autocomplete(
      input,
      options,
    );
    this.placesAutoCompleteRef.current.addListener('place_changed', () => {
      this.handleInputSubmit(null);
    });
  }

  /**
   * Clear input field from search value
   * @function
   * @name clearSearchText
   */
  clearSearchText(event) {
    document.getElementById('location_text').value = null;
    document.getElementById('clear').style.display = 'none';
    document.getElementById('clear-text').innerHTML = null;
  }

  /**
   * Add clear icon when input field has data
   * @function
   * @name handleInputText
   */
  handleInputText = event => {
    if (
      document.getElementById('location_text').value == '' ||
      document.getElementById('location_text').value == ''
    ) {
      document.getElementById('clear-text').innerHTML = null;
      document.getElementById('clear').style.display = 'none';
    } else {
      document.getElementById('clear').style.display = 'block';
    }
  };

  handleGaEvent = () => {
    window.gtag('event', 'SearchBar:InvestmentPropertyPage', {
      event_category: 'SearchBar',
      event_label: 'SearchBar:InvestmentPropertyPage:Search',
    });
  };

  render() {
    return (
      <div className={styles2.cityHeader}>
        <h1 className={styles.searchBarMainText}>{this.title}</h1>

        <h2
          className={`${styles.searchBarSubText} ${styles2.searchBarSubText}`}
        >
          {this.subtitle}
        </h2>

        <div className={styles.searchBarBlock}>
          <form
            name="search"
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            <div className={styles.inputGroup}>
              <div className={styles.relativePosition}>
                <input
                  onClick={this.handleGaEvent}
                  onChange={this.handleInputText}
                  type="text"
                  aria-label="search location"
                  name="location"
                  className={styles.searchBarText}
                  id="location_text"
                  placeholder="Enter an address, neighborhood, city or ZIP code"
                  size="60"
                  ref={this.autoCompleteInputRef}
                  data-cy="search-box"
                ></input>
              </div>

              <span
                className={`${styles.inputGroupBtn} ${styles.searchClear} ${styles.displayInline}`}
                style={{ display: 'none' }}
                id="clear"
                onClick={this.clearSearchText}
              >
                <a
                  className={`${styles.btn} ${styles.btnLink} ${styles.clearButton}`}
                  aria-label="clear"
                >
                  <span className={styles.glyphicon}>
                    <FaTimes />
                  </span>
                  <i className={styles.glyphicon} id="clear-text"></i>
                </a>
              </span>

              <span
                onClick={this.handleInputSubmit}
                className={styles.searchBarButton}
              >
                <a
                  className={`${styles.btn} ${styles.btnCta} ${styles.btnCtaPrimary}`}
                  id="analyze"
                  aria-label="analyze"
                >
                  <span className={styles.searchBtnText}>Start Analyzing</span>
                  <span className={styles.searchBtnIcon}>
                    <FaSearch />
                  </span>
                </a>
              </span>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default ProductSearchBar;
